var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44093 2.91804C4.94093 3.27204 4.48193 3.68204 4.06593 4.14604C1.21693 7.31704 1.30993 12.391 4.27293 15.456C5.83893 17.077 7.94293 17.981 10.1969 18C10.2219 18.001 10.2479 18.001 10.2739 18.001C12.4989 18.001 14.5879 17.138 16.1639 15.565C16.4919 15.238 16.7899 14.887 17.0569 14.513C13.9109 14.905 10.6859 13.851 8.39493 11.565C6.10493 9.27904 5.04493 6.06104 5.44093 2.91804ZM10.2739 20.001C10.2419 20.001 10.2109 20.001 10.1789 20C7.38493 19.976 4.77593 18.856 2.83493 16.847C-0.842067 13.042 -0.957066 6.74504 2.57693 2.81004C3.67793 1.58304 5.02193 0.660043 6.57093 0.0670431C6.93593 -0.0749569 7.35093 0.0130431 7.62993 0.289043C7.90893 0.564043 8.00193 0.977043 7.86693 1.34504C6.74893 4.40004 7.51093 7.85604 9.80793 10.149C12.1059 12.442 15.5709 13.203 18.6359 12.087C19.0039 11.951 19.4179 12.047 19.6919 12.325C19.9659 12.606 20.0529 13.02 19.9119 13.385C19.3879 14.748 18.6019 15.958 17.5759 16.981C15.6229 18.931 13.0329 20.001 10.2739 20.001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.c4c853c33f425df5c356823779d3a9f4.svg";
export { ForwardRef as ReactComponent };